module.exports = __webpack_public_path__ + "img/plus.0fd1791b.svg";